// @flow

import React from 'react'
import {Language} from '@/types'
import GoAlert from 'react-icons/lib/go/alert'
import './info-alert.css'

type Props = {
  alertText: string,
  l: Language,
}

const InfoAlert = (props: Props) => (
  <div className='info-alert-ctr'>
    <a data-text={props.l(props.alertText)}><GoAlert/></a>
  </div>
)

export default InfoAlert



// WEBPACK FOOTER //
// ./src/elements/info-alert.js